var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('multi-select',{staticClass:"winners-drop-down",attrs:{"options":_vm.options,"value":_vm.value,"show-pointer":true,"searchable":false,"select-label":"","deselect-label":"","selected-label":"","placeholder":_vm.placeholder},on:{"select":value => _vm.select(value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }